import { render, staticRenderFns } from "./revokeorder.vue?vue&type=template&id=53f23658&"
import script from "./revokeorder.vue?vue&type=script&lang=js&"
export * from "./revokeorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports